document.querySelectorAll('[data-add-btn]').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault(); // prevent default action if it's a link or submit

    const target = document.querySelector('.tt-product-single-info');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start' // aligns at the top of viewport
      });
    }
  });
});
